import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/onboarding/coverage')({
  component: () => <Navigate to='/onboarding' />,
})
